export const getQueryParam = (uri, param) => {
  if (!uri) return

  return (uri.startsWith("http")
    ? new URLSearchParams(new URL(uri).search)
    : uri.startsWith("/") || uri.startsWith("?")
    ? new URLSearchParams(uri.split("?")[1])
    : new URLSearchParams(uri)
  ).get(param)
}

export const hashToString = hash =>
  hash.startsWith("#") ? hash.substring(1) : hash

export const toHashList = hashString => {
  const hash = hashString || ""

  if (hash.startsWith("#")) {
    return hash
      .substring(1)
      .split("+")
      .filter(t => !!t)
      .map(hash => hash.split("?")[0])
  } else {
    return hash
      .split("+")
      .filter(t => !!t)
      .map(hash => hash.split("?")[0])
  }
}

export const addToHash = (currentHash, hash) => {
  const list = toHashList(currentHash)
  const hashString = hashToString(hash)

  return `#${
    list.includes(hashString) ? hashString : [...list, hashString].join("+")
  }`
}

export const removeFromHash = (currentHash, hash) => {
  const list = toHashList(currentHash)
  const hashString = hashToString(hash)
  return `#${list.filter(h => h !== hashString).join("+")}`
}

export const getPathFromUrl = (url, inclusive) => {
  const urlObj = url.startsWith("http")
    ? new URL(url)
    : new URL(`https://example.com${url}`)

  return inclusive
    ? urlObj.pathname + urlObj.search + urlObj.hash
    : urlObj.pathname
}
